import { Component, OnInit } from '@angular/core';
// import { SearchService } from '../search.service';
import { Router } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';

@Component({
  selector: 'app-search-widget',
  templateUrl: './search-widget.component.html',
  styleUrls: ['./search-widget.component.scss'],
  animations: fuseAnimations,
})
export class SearchWidgetComponent implements OnInit {
  value: string;

  constructor(
    // private searchService: SearchService,
    private router: Router,
  ) { }

  ngOnInit() {
  }

  search() {
    // console.log(this.value);
    // this.searchService.searchFor(this.query);
    // this.router.navigate(['search']);
  }

  input(string){
    
  }

}
